import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/BlindsCode/bc-tracking-wt/app/products/[slug]/FabricGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/BlindsCode/bc-tracking-wt/app/products/[slug]/PdpTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/BlindsCode/bc-tracking-wt/app/products/[slug]/ProductImageGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/BlindsCode/bc-tracking-wt/components/ecommerce/MobilePurchaseBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/gopal/BlindsCode/blindscommerce/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/node_modules/next/dist/client/image-component.js");
